import LogCannon from '@ace-clublabs/log-cannon';
import { getEnvironmentName } from '../config/env';

let isInitialized = false;

export const initializeLogger = (): void => {
  if (isInitialized) return;

  const apiKey = import.meta.env.VITE_LOGCANNON_API_KEY || '';

  // Use string values directly to avoid type version mismatches between aws-tags versions
  LogCannon.init(apiKey, {
    team: 'cloud-ops' as any,
    component: 'links-alp-web',
    workload: 'cloud-ops' as any,
    runtime: 'browser',
    runtimeVersion: navigator.userAgent,
  });

  isInitialized = true;
  LogCannon.blast('Application initialized', { environment: getEnvironmentName() });
};

export const logFlowStep = (
  flow: 'auth' | 'public',
  step: string,
  context?: Record<string, string | number | boolean>
): void => {
  LogCannon.blast(`${flow}:${step}`, { flow, step, ...context });
};

export const logApiCall = (
  endpoint: string,
  method: string,
  statusCode: number,
  durationMs: number,
  isSuccess: boolean
): void => {
  const level = isSuccess ? 'blast' : 'error';
  LogCannon[level]('API call ' + (isSuccess ? 'completed' : 'failed'), {
    endpoint: endpoint.split('?')[0], // Remove query params
    method,
    statusCode,
    durationMs,
    isSuccess,
  });
};

export const logError = (
  errorType: string,
  message: string,
  context?: Record<string, string | number | boolean>
): void => {
  LogCannon.error(`Error: ${errorType}`, {
    errorType,
    message: message.substring(0, 200),
    ...context,
  });
};

export const logRedirect = (keyword: string, alpid: number, clubCode: string): void => {
  LogCannon.blast('Redirect executing', { keyword, alpid, clubCode });
};
